<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-narrow-up" width="12" height="20" viewBox="6 4 10 20" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round">
    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="16" y1="9" x2="12" y2="5" />
    <line x1="8" y1="9" x2="12" y2="5" />
  </svg>
</template>
  
<script>
  export default {}
</script>
  
<style>
 
</style>